// extracted by mini-css-extract-plugin
module.exports = {"heading":"references_heading__Wkblu","content":"references_content__1Gx6y","sending":"references_sending__2pmi1"};